module.exports = __webpack_public_path__ + "img/tripko_logo.03fcf157.png";